<template>
  <b-modal
    id="modal-supplier-document-detail"
    title="供應商帳單詳情"
    size="lg"
    scrollable
  >
    <div v-if="documentDetail && Object.keys(documentDetail).length > 0">
      <!-- 基本信息 -->
      <b-card class="">
        <b-card-header class="pb-2">
          <h5 class="mb-0">
            <feather-icon icon="FileTextIcon" class="mr-50" />
            基本信息
          </h5>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col md="6">
              <div class="mb-2">
                <strong>供應商：</strong>
                <div class="mt-1">
                  <div>{{ documentDetail.supplier.name }}</div>
                  <small class="text-muted">{{ documentDetail.supplier.name_cn }}</small>
                  <br>
                  <small class="text-muted">{{ documentDetail.supplier.company_name_cn }}</small>
                </div>
              </div>
              <div class="mb-2">
                <strong>帳單金額：</strong>
                <span class="text-success font-weight-bold">${{ documentDetail.amount || 0 }}</span>
                <small v-if="!documentDetail.items || documentDetail.items.length === 0" class="text-muted d-block">
                  (舊版帳單，無詳細項目分解)
                </small>
              </div>
              <div class="mb-2">
                <strong>上傳日期：</strong>
                {{ getDateTime(documentDetail.created_at) }}
              </div>
            </b-col>
            <b-col md="6">
              <div class="mb-2">
                <strong>埋數狀態：</strong>
                <b-badge :variant="documentDetail.is_approved == 1 ? 'success' : 'warning'">
                  {{ documentDetail.is_approved == 1 ? '已埋數' : '未埋數' }}
                </b-badge>
              </div>
              <div v-if="documentDetail.is_approved == 1" class="mb-2">
                <strong>埋數人員：</strong>
                {{ documentDetail.approve_user ? documentDetail.approve_user.name_cn : '-' }}
              </div>
              <div v-if="documentDetail.remark" class="mb-2">
                <strong>埋數備註：</strong>
                {{ documentDetail.remark }}
              </div>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <!-- 帳單項目 -->
      <b-card class="mb-3">
        <b-card-header class="pb-2">
          <h5 class="mb-0">
            <feather-icon icon="ListIcon" class="mr-50" />
            帳單項目
          </h5>
        </b-card-header>
        <b-card-body>
          <div v-if="documentDetail.items && documentDetail.items.length > 0">
            <b-table
              :items="documentDetail.items"
              :fields="itemFields"
              responsive
              small
            >
              <template #cell(invoice_number)="data">
                {{ getInvoiceNumber(data.item.invoice_id) }}
              </template>
              <template #cell(amount)="data">
                ${{ data.item.amount }}
              </template>
            </b-table>
          </div>
          <div v-else class="text-center py-3">
            <feather-icon icon="InfoIcon" class="text-muted mb-2" size="24" />
            <p class="text-muted mb-0">此為舊版帳單，無詳細項目記錄</p>
            <small class="text-muted">帳單總金額：${{ documentDetail.amount || 0 }}</small>
          </div>
        </b-card-body>
      </b-card>

      <!-- 附件預覽 -->
      <b-card class="mb-3">
        <b-card-header class="pb-2">
          <h5 class="mb-0">
            <feather-icon icon="ImageIcon" class="mr-50" />
            附件預覽
          </h5>
        </b-card-header>
        <b-card-body>
          <div class="text-center">
            <template v-if="documentDetail.image_url.indexOf('.pdf') > -1">
              <embed
                class="pdf-preview"
                style="width: 100%; height: 400px; border: 1px solid #ddd;"
                :src="documentDetail.image_url"
                type="application/pdf"
              />
            </template>
            <template v-else>
              <img 
                style="max-width: 100%; max-height: 400px; border: 1px solid #ddd;" 
                :src="documentDetail.image_url" 
                alt="帳單圖片" 
                class="img-fluid"
              >
            </template>
            <div class="mt-2">
              <b-button
                variant="outline-primary"
                size="sm"
                @click="previewFullImage"
              >
                <feather-icon icon="ZoomInIcon" class="mr-25" />
                全屏預覽
              </b-button>
              <b-button
                variant="outline-secondary"
                size="sm"
                class="ml-2"
                :href="documentDetail.image_url"
                target="_blank"
              >
                <feather-icon icon="DownloadIcon" class="mr-25" />
                下載
              </b-button>
            </div>
          </div>
        </b-card-body>
      </b-card>


    </div>

    <!-- 加載狀態 -->
    <div v-else class="text-center py-5">
      <b-spinner variant="primary" />
      <div class="mt-2">加載中...</div>
    </div>

    <!-- 圖片預覽模態框 -->
    <modal-image-viewer
      :image-list="previewImageList"
      :selected_file="0"
    />

    <!-- 自定義 Footer -->
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-end">
        <!-- <b-button
          v-if="ability.can('approve', 'staff_supplier_documents') && documentDetail.is_approved == 0"
          variant="success"
          class="mr-2"
          @click="handleApproval"
        >
          <feather-icon icon="CheckIcon" class="mr-25" />
          埋數
        </b-button> -->
        <b-button
          v-if="ability.can('update_document', 'staff_supplier_documents')"
          variant="primary"
          class="mr-2"
          @click="handleEdit"
        >
          <feather-icon icon="EditIcon" class="mr-25" />
          編輯
        </b-button>
        <b-button
          v-if="ability.can('delete_document', 'staff_supplier_documents')"
          variant="danger"
          class="mr-2"
          @click="handleDelete"
        >
          <feather-icon icon="Trash2Icon" class="mr-25" />
          刪除
        </b-button>
        <b-button
          variant="secondary"
          @click="$bvModal.hide('modal-supplier-document-detail')"
        >
          關閉
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BBadge,
  BTable,
  BButton,
  BSpinner,
} from "bootstrap-vue";
import { formatCurrency } from "@core/utils/filter";
import ability from "@/libs/acl/ability";
import ModalImageViewer from "@/layouts/components/file/ModalImageViewer.vue";

export default {
  name: "SupplierDocumentDetail",
  components: {
    BModal,
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BBadge,
    BTable,
    BButton,
    BSpinner,
    ModalImageViewer,
  },
  props: {
    documentDetail: {
      type: Object,
      default: () => ({}),
    },
    invoiceOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ability,
      itemFields: [
        { key: "title", label: "項目名稱" },
        { key: "invoice_number", label: "發票號碼" },
        { key: "amount", label: "金額", formatter: formatCurrency },
      ],
      previewImageList: [],
    };
  },
  methods: {
    getDateTime(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString('zh-TW', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    getInvoiceNumber(invoice_id) {
      const invoice = this.invoiceOptions.find(invoice => invoice.id === invoice_id);
      return invoice ? invoice.invoice_number : '-';
    },
    previewFullImage() {
      this.previewImageList = [{
        id: this.documentDetail.id,
        src: this.documentDetail.image_url,
        name: this.documentDetail.name || '帳單附件',
        type: this.documentDetail.image_url.indexOf("pdf") > -1 ? "application/pdf" : "image/jpeg",
      }];
      
      setTimeout(() => {
        this.$bvModal.show('modal-image-viewer');
      }, 100);
    },
    // handleApproval() {
    //   this.$emit('approve', this.documentDetail);
    //   this.$bvModal.hide('modal-supplier-document-detail');
    // },
    handleEdit() {
      this.$emit('edit', this.documentDetail);
      this.$bvModal.hide('modal-supplier-document-detail');
    },
    handleDelete() {
      this.$emit('delete', this.documentDetail);
      this.$bvModal.hide('modal-supplier-document-detail');
    },
  },
};
</script>

<style scoped>
.pdf-preview {
  border-radius: 0.375rem;
}
</style>
